import Inputmask from "inputmask"

export class SoliciteaquiMask {
    constructor() {
        this.telefoneElement = document.querySelector("#input-telefone")
        this.dddElement = document.querySelector("#input-ddd")
        this.init()
    }

    init() {
        Inputmask.extendDefaults({
            'autoUnmask': true
        });
        
        if(this.telefoneElement)
            Inputmask("integer", { rightAlign: false }).mask(this.telefoneElement)

        if(this.dddElement)
            Inputmask("integer", { rightAlign: false }).mask(this.dddElement)
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-soliciteaqui/masks.js